import { backendRequest } from "@/lib/backend/api";

type NotificationType =
  | "message"
  | "deal"
  | "like"
  | "payment"
  | "system"
  | "error"
  | "follow"
  | "post"
  | "live_stream"
  | "violation"
  | "dispute"
  | "video_like"
  | "video_tip"
  | "comment";

interface NotificationPayload {
  title: string;
  body: string;
  type: NotificationType;
  recipient_id: string;
  sender_id: string;
}

class NotificationService {
  public async createNotification(payload: NotificationPayload) {
    try {
      await backendRequest("/api/v1/notifications", {
        method: "POST",
        body: JSON.stringify({
          recipientId: payload.recipient_id,
          senderId: payload.sender_id,
          title: payload.title,
          body: payload.body,
          type: payload.type,
        }),
      });

      this.showLocalNotification(payload.title, payload.body);
    } catch (error) {
      console.error("Notification error:", error);
    }
  }

  private async showLocalNotification(title: string, body: string) {
    try {
      const audio = new Audio("/assets/sounds/notification.mp3");
      audio.play().catch(() => undefined);

      if ("vibrate" in navigator) navigator.vibrate([200, 100, 200]);

      if (Notification.permission === "granted") {
        new Notification(title, { body, icon: "/logo.png" });
      }
    } catch (error) {
      console.error("Local notification error:", error);
    }
  }

  public listenForUserNotifications(_userId: string) {
    return (() => undefined) as (() => void) & { unsubscribe?: () => void };
  }
}

export const notificationService = new NotificationService();
